"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponsiveStyle = void 0;
function getResponsiveStyle(styleValue, resolver) {
    if (Array.isArray(styleValue)) {
        return styleValue.map((item) => item !== null ? resolver(item) : null);
    }
    else {
        return resolver(styleValue);
    }
}
exports.getResponsiveStyle = getResponsiveStyle;
//# sourceMappingURL=getResponsiveStyle.js.map